import { Attribute, Directive, Injector, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { AppComponentBase } from '@shared/app-component-base';
import * as moment from 'moment';

@Directive({
  selector: '[validateGreaterOrEqualThanTwice][ngModel],[validateGreaterOrEqualThanTwice][formControl]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => GreaterOrEqualThanTwiceValidator),
      multi: true
    }
  ]
})
export class GreaterOrEqualThanTwiceValidator extends AppComponentBase implements Validator {
  constructor(injector: Injector, @Attribute('validateGreaterOrEqualThanTwice') public startDate: string) {
    super(injector);
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const startDateControl = control.root.get(this.startDate);
    const endDateControl = control;

    if (!startDateControl || !endDateControl) {
      return null;
    }

    const startDate = moment(startDateControl.value, this.getDateInputFormat(), true);
    const endDate = moment(endDateControl.value, this.getDateInputFormat(), true);

    return startDate.isAfter(endDate, 'day') ? { validateGreaterOrEqualThanTwice: true } : null;
  }
}
